module.exports = __webpack_public_path__ + "static/img/t-4.30556a60.png";